<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  team: {
    type: Object,
    required: true,
    validator: value =>
      typeof value?.name === 'string' && value.name.length > 0,
  },
});

const { t } = useI18n();

const teamName = computed(() => props.team.name);
const ariaLabel = computed(() =>
  t('CONVERSATION.CARD.TEAM_LABEL', { name: teamName.value })
);
</script>

<template>
  <span
    class="inline-flex items-center h-5 min-w-0 gap-1 py-0 px-1.5 rounded border border-n-strong text-n-slate-11"
    :title="ariaLabel"
    :aria-label="ariaLabel"
  >
    <fluent-icon icon="people-team" size="12" class="flex-shrink-0" />
    <span class="text-xs font-medium leading-3 truncate">{{ teamName }}</span>
  </span>
</template>
